import { KeyValue } from '@/main/models/common';
import { DamageAreaRequest } from '@/main/models/request/orderRequest';

export enum DamageAreaTypes {
  GET_DAMAGEAREAS = '@damageArea/GET_DAMAGEAREAS',
  SAVE_DAMAGEAREAS = '@damageArea/SAVE_DAMAGEAREAS',
  RESET_REDUCER_DAMAGEAREAS = '@damageArea/RESET_REDUCER_DAMAGEAREAS'
}

export interface DamageAreaState {
  readonly damageAreas: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetDamageAreas {
  type: typeof DamageAreaTypes.GET_DAMAGEAREAS;
}

export interface SaveDamageAreas {
  type: typeof DamageAreaTypes.SAVE_DAMAGEAREAS;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerDamageAreas {
  type: typeof DamageAreaTypes.RESET_REDUCER_DAMAGEAREAS;
}

export type DamageAreaActionTypes =
  | GetDamageAreas
  | SaveDamageAreas
  | ResetReducerDamageAreas;
